/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { SurveyServiceGenerated } from './services/survey-service-generated';
import { UserSurveyServiceGenerated } from './services/user-survey-service-generated';
import { NotificationLogServiceGenerated } from './services/notification-log-service-generated';
import { ConsentServiceGenerated } from './services/consent-service-generated';
import { UserConsentServiceGenerated } from './services/user-consent-service-generated';
import { OtpRequestServiceGenerated } from './services/otp-request-service-generated';
import { UserOtpRequestServiceGenerated } from './services/user-otp-request-service-generated';
import { BusinessUnitServiceGenerated } from './services/business-unit-service-generated';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    SurveyServiceGenerated,
    UserSurveyServiceGenerated,
    NotificationLogServiceGenerated,
    ConsentServiceGenerated,
    UserConsentServiceGenerated,
    OtpRequestServiceGenerated,
    UserOtpRequestServiceGenerated,
    BusinessUnitServiceGenerated,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
